import React, { useEffect, useState, useRef, forwardRef } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { compose } from 'redux';
import withWindowResizeHandler from "../../../../hocs/with_window_resize_handler.js";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import Image from "../../../../base/components/image.js";
import IcWhiteArrowLeft from "../../../../resources/icons/arrows/ic_white_arrow_left.js";
import IcWhiteArrowRight from "../../../../resources/icons/arrows/ic_white_arrow_right.js";


const blockStyles = makeStyles(theme => ({
  root: {
    overflow: "hidden",
    position: "relative",
    height: "500px",
    ['@media (max-width: 768px)']: {
      height: "276px"
    },
  },
  slider: {
    height: "100%",
    "& .slick-prev": {
      left: "80px",
      zIndex: "1",
      ['@media (max-width: 768px)']: {
        display: "none"
      },
    },
    "& .slick-next": {
      right: "80px",
      zIndex: "1",
      ['@media (max-width: 768px)']: {
        display: "none"
      },
    },
    "& .slick-dots": {
      bottom: "0px",
      display: "none !important",
      ['@media (max-width: 768px)']: {
        display: "block !important"
      },
    },
    "& ul": {
      padding: "0px",
    },
    "& ul li": {
      padding: "0px !important",
      pointerEvents: "none",
      height: "8px",
      width: "8px",
      backgroundColor: "transparent",
      borderRadius: "4px",
      border: `1px ${theme.palette.white} solid`,
      marginBottom: "7px !important"
    },
    "& ul li button": {
      display: "none"
    },
    "& ul li.slick-active": {
      backgroundColor: theme.palette.white
    },
    "& ul li:first-child": {
      marginLeft: "0px"
    },
    "& ul li:last-child": {
      marginRight: "0px"
    }
  },
  image: {
    borderLeft: "1px solid white",
    display: "block",
    margin: "auto",
    cursor: "pointer",
    height: "500px",
    ['@media (max-width: 768px)']: {
      height: "276px",
      width: "100% !important",
      borderLeft: "none"
    },
  },
}));

const GalleryBlock = forwardRef((props, ref) => {
  const classes = blockStyles();

  const { className, galleryImages } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [containerHeight, setContainerHeight] = useState();

  const settings = {
    // autoplay: true,
    // autoplaySpeed: 10000,
    centerMode: false,
    infinite: true,
    slidesToShow: 1,
    speed: 900,
    swipe: false,
    variableWidth: true,
    dots: true,
    prevArrow: <IcWhiteArrowLeft />,
    nextArrow: <IcWhiteArrowRight />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          swipeToSlide: true,
          slidesToShow: 1,
          swipe: true,
          speed: 300
        }
      },
    ]
  }

  useEffect(() => {
    setContainerHeight(props.height);
  }, [props.height]);

  if(galleryImages.length == 0) {
    return (null);
  }

  if(galleryImages.length > 0) {
    let images = galleryImages.map((item) => {
      return item.urls.big
    })

    if(galleryImages.length > 1) {
      return(
        <div className = { clsx(classes.root, className) }
             ref = { ref } >  
          <Slider {...settings} className = { classes.slider } >
            {
              galleryImages.map((item, index) => {
                return <Image src = { item.urls.large } 
                              className = { classes.image }
                              srcSet = { {
                                "2x": item.urls.large2x,
                                "3x": item.urls.large3x,
                              } }
                              key = { item.id }
                              imgWidth = { calcWidth(containerHeight, item.height, item.width) }
                              imgHeight = { containerHeight }
                              onClick = {() => {
                                setIsOpen(true)
                                setPhotoIndex(index)
                              }}/>              
              })
            }
          </Slider>
          { isOpen && 
            <Lightbox mainSrc={images[photoIndex]}
                      nextSrc={images[(photoIndex + 1) % images.length]}
                      prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + images.length - 1) % images.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                      }
          />}                 
        </div>
      )
    }
    else {
      return(
        <div className = { clsx(classes.root, className) } >
          <div className = { classes.slider }>
            <img className = { classes.image }
                 src = { galleryImages[0].urls.large }
                 onClick = {() => setIsOpen(true)}/>        
          </div>
          { isOpen && 
            <Lightbox mainSrc={images[photoIndex]}
                      onCloseRequest={() => setIsOpen(false)}
          />}      
        </div>
      )
    }  
  }
  else {
    return null
  }
})

const calcWidth = (currentHeight, originalHeight, originalWidth) => {
  const multiple = currentHeight / originalHeight
  let width = originalWidth * multiple
  width = width.toFixed(2)
  return parseInt(width)
}

export default compose(withWindowResizeHandler)(GalleryBlock);
